import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_LL1Parser = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="LL1 parser (Predictive Parser)"
    videos={[
      "https://www.youtube.com/embed/QoOALbef3ZM",
      "https://www.youtube.com/embed/a5F2ymWspfQ",
    ]}
    takeaways={[
      { text: "Learn how to find FIRST and FOLLOW sets clearly" },
      { text: "In top-down parsers, this is more important" },
      { text: "Mostly, questions will be asked whether the grammar is LL1 grammar or not" },
    ]}
    questions={[
      `Consider the following grammar:

S->AB
A-> aAb | ε
B->bB | c

a) Compute the First and Follow sets for each non-terminal symbol.
b) Construct the LL(1) parsing table for the grammar.
c) Use the LL(1) parsing table to parse the input string "aabc" and show the step-by-step derivation.`,

      `Consider the given Grammar G = (V, T, P, S) where S->ACB|cbB|Ba, A->da|BC, B->g|ε, C->h|ε are the production rules. Is the given grammar suitable for LL(1) parser construction? Justify your answer with an explanation. Construct an LL(1) predictive parsing table for the given grammar. Illustrate the LL(1) string parsing procedure for the given string w=dag.`,

      `In the following context-free grammar, the symbols a, b, c and d are terminals and P is the initial symbol. P->a|bPcPd|bQd Q->P|QP 
i) Explain briefly why this grammar is not LL(1). 
ii) Convert this grammar to an equivalent that is LL(1). 
iii) For the grammar of the previous subtask, construct the complete LL(1) parsing table. 
iv) Show all the steps required to parse the input string: bbacadabadd`,

      `Consider the following grammar: 
i. Write a new grammar that accepts the same language but avoids left recursion and common left prefixes and figure out the FIRST and FOLLOW sets for the new grammar. 
ii. Construct the LL (1) parse table for the new grammar; is the new grammar LL (1) grammar? Explain your answer carefully.

P->S 
P->SP 
S -> If E then S 
S -> if E then S else S 
S -> while E S 
S -> begin P end 
S -> print E 
S-> E 
E -> id 
E -> integer 
E->E+E`,

      `Construct the predictive parsing table for the grammar S->(L)|a, L->L,S|S Show that the given string can be accepted or not, (a, a)$.`,
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_LL1Parser;
